import { render } from "./Home.vue?vue&type=template&id=d10c1076"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=d10c1076&lang=css"

import exportComponent from "/vercel/path0/Web_Apps/Dorm_Review/WebUI/UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__